import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LanguageStoreService } from '@cinetixx/cinetixx-ui';


export const NoLangGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  languageStore = inject(LanguageStoreService)
): boolean => {
  location.href = `/${ languageStore.language?.token ?? environment.fallbackLanguage }`;

  return true;
};
